import React from 'react'
import HomePage from './page/home/HomePage'
const App = () => {
  return (
    <HomePage/>
    
  )
}

export default App